import React from "react";
import { Button, Typography, Card, Space } from "antd";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import SpinFC from "antd/lib/spin";

const BankQRResult = ({ qrUrl, qrRef, onPrint, onDownload, loading }) => {
  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0, textAlign: "center" }}>
          Mã QR của bạn
        </Typography.Title>
      }
      bordered={false}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 66,
      }}
    >
      {qrUrl ? (
        <>
          <div
            style={{
              width: "100%",
              margin: "auto",
              padding: 24,
              textAlign: "center",
            }}
            ref={qrRef}
          >
            <img
              src={qrUrl}
              alt="VietQR"
              style={{
                width: "60%",
                margin: "0 auto",
                marginBottom: 8,
              }}
            />
          </div>
          <Space>
            <Button onClick={onPrint} icon={<PrinterOutlined />} type="primary">
              In mã QR
            </Button>
            <Button
              onClick={onDownload}
              icon={<DownloadOutlined />}
              type="primary"
            >
              Tải mã QR
            </Button>
          </Space>
        </>
      ) : (
        <>
          {loading ? (
            <SpinFC spinning={loading}/>
          ) : (
            <Typography>Chưa có mã QR</Typography>
          )}
        </>
      )}
    </Card>
  );
};

export default BankQRResult;
